import { render, staticRenderFns } from "./pcpage.vue?vue&type=template&id=47ee2827&scoped=true&"
import script from "./pcpage.vue?vue&type=script&lang=js&"
export * from "./pcpage.vue?vue&type=script&lang=js&"
import style0 from "./pcpage.vue?vue&type=style&index=0&id=47ee2827&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ee2827",
  null
  
)

export default component.exports